/* eslint-disable */
import { useSelector } from "react-redux";
import { useState } from "react";
import { IconSvg } from "../../../../../../../../../../utils/constants/icons/iconSvg.constant";
import "./ProxyList.scss";
import { ProxyItem } from "../ProxyItem/ProxyItem";
import { Pagination } from "../../../../../../../../../../components/common/Pagination/Pagination";
import { Filter } from "../Filter/Filter";
import { NewListIpModal } from "../NewListIpModal/NewListIpModal";
import { ChangeTariffModal } from "../ChangeTariffModal/ChangeTariffModal";
import { AddGbModal } from "../AddGbModal/AddGbModal";
import { ChangeRotationModal } from "../ChangeRotationModal/ChangeRotationModal";
import { useTranslation } from "../../../../../../../../../../hooks";

const proxies = [
  { name: "List 1", date: "Sep 22, 2024  14:35", authType: "login", login: "User128", password: "178RTjiey64747859", authIp: "", geo: "USA, Pittsburgh, PA", ips: "Broadband", ports: "10", exportFormat: "File" },
  { name: "List 2", date: "Sep 22, 2024  14:35", authType: "ip", login: "User128", password: "178RTjiey64747859", authIp: "192.168.0.1", geo: "USA, Pittsburgh, PA", ips: "Broadband", ports: "10", exportFormat: "File" },
  { name: "List 3", date: "Sep 22, 2024  14:35", authType: "login", login: "User128", password: "178RTjiey64747859", authIp: "", geo: "USA, Pittsburgh, PA", ips: "Broadband", ports: "10", exportFormat: "File" },
  { name: "List 4", date: "Sep 22, 2024  14:35", authType: "login", login: "User128", password: "178RTjiey64747859", authIp: "", geo: "USA, Pittsburgh, PA", ips: "Broadband", ports: "10", exportFormat: "File" }
];

export const ProxyList = () => {
  const [isNewListModalOpen, setIsNewListModalOpen] = useState(false);
  const [isChangeTariffModalOpen, setIsChangeTariffModalOpen] = useState(false);
  const [isAddGbModalOpen, setIsAddGbModalOpen] = useState(false);
  const [isChangeRotationModalOpen, setIsChangeRotationModalOpen] = useState(false);

  const { skin } = useSelector((state) => state.header);
  const { cabinet: { orders: { residential: { proxyList, listIp, noList } } } } = useTranslation();

  return (
    <>
      <div className="proxy-list">
        <div className="proxy-list__title">
          <div className="general__title">{proxyList}</div>
          <Filter />
        </div>
        <button className="proxy-list__add-proxy" onClick={() => setIsNewListModalOpen(true)}>
          <IconSvg tag="thinPlus"/>
          <div>{listIp}</div>
        </button>
      </div>
      {proxies.length ? (
        <>
          <ul className="proxy-list__proxy-items">
            {proxies.map((proxy) => <ProxyItem key={proxy.name} proxy={proxy}/>)}
          </ul>
          <div className="proxy-list__pagination">
            <Pagination totalPages={10}/>
          </div>
        </>
      ) : (
        <div className="proxy-list__empty">
          <div className="proxy-list__empty-icon">
            <IconSvg tag={`proxyListEmpty_${skin}`}/>
          </div>
          <div className="proxy-list__empty-text">{noList}</div>
        </div>
      )}
      {isNewListModalOpen && <NewListIpModal onClose={() => setIsNewListModalOpen(false)} />}
      {isChangeTariffModalOpen && <ChangeTariffModal />}
      {isAddGbModalOpen && <AddGbModal />}
      {isChangeRotationModalOpen && <ChangeRotationModal />}
    </>
  );
};
